/* eslint-disable no-unused-vars */
import { memo, useState, useMemo } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ShareIcon from '@mui/icons-material/Share'; // Import Share icon
import { useDispatch, useSelector } from 'react-redux';
import Swal from "sweetalert2";
import { CustomTable } from '../../../components/customTable/customTable';
import { customStep, emptyJob, update } from '../../../slice/jobSlice';
import CustomSwal from "../../../components/SwalPopup/customSwal";
import { FRONTEND_URL } from "../../../appConstants";
import { useAccessControl } from '../../../components/AccessControl';
import { sendOfferToClinician } from '../../../utils/jobOfferAPI';
import "./facilityJobs.css"
import { width } from "@mui/system";
import toast from "react-hot-toast";
import { format } from "date-fns";
const Jobs = ({ access }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { controlBy } = useSelector(state => state.user);
  const { isFullAccess } = useAccessControl(access);
  const [event, setEvent] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const routeto = searchParams.get("routeto") || null;
  const clinician = searchParams.get("clinician");

  const handleViewJob = (row) => {
    if (row.JOB_STATUS === "Draft Application") {
      CustomSwal({
        title: "Your job post is saved as a draft",
        text: "Do you want to complete and finalize it to make it live?",
        footer: ``,
        onConfirm: () => handleEditJob(row),
        onCancel: () => { Swal.close(); },
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: 'custom-swal-confirm',
          cancelButton: 'custom-swal-cancel',
          closeButtonText: 'custom-swal-close',
        },
      });
      // return showToast('error', 'Your job post is saved as a draft. Please complete and finalize it to make it live.')
    } else {
      if (row.SERVICE_TYPE === "One Time") {
        row.JOB_OUT_TIME = row.job_services[0]?.JOB_OUT_TIME
        row.JOB_IN_TIME = row.job_services[0]?.JOB_IN_TIME
      } else {
        row.JOB_SERVICE_WITH_DAY_TIME = row.job_services
      }
      dispatch(update({ ...row, MODE: "Edit", INITIALSTEP: row.STEP }))
      dispatch(customStep(row.STEP))
      navigate("/facility/viewJob")
    }

  }
  const handleEditJob = (row) => {
    // return console.log("row", row)
    if (row.SERVICE_TYPE === "One Time") {
      row.JOB_OUT_TIME = row.job_services[0]?.JOB_OUT_TIME
      row.JOB_IN_TIME = row.job_services[0]?.JOB_IN_TIME
    } else {
      row.JOB_SERVICE_WITH_DAY_TIME = row.job_services;
    }
    console.log("roewew", row);
    // return;
    dispatch(update({ ...row, MODE: "Edit", INITIALSTEP: row.STEP }));
    dispatch(customStep(row.STEP))
    navigate("/facility/jobs/postJob", { state: "Edit" })
  }

  // const handleShare = (row) => {
  //   console.log("Share ", row);
  //   CustomSwal({
  //     title: "Share Job",
  //     text: `Do you want to share "${row.jobs_role?.ROLE_NAME}" job with selected clinician`,
  //     footer: ``,
  //     onConfirm: () => {
  //       const currentShareLink = `${FRONTEND_URL}login?ref=${row?.ID}&&refType=${row?.HIRING_TYPE}`;
  //       sessionStorage.setItem("ShareJobLink", currentShareLink);
  //       sessionStorage.setItem("Clinician", clinician);
  //       navigate(`/facility/messages/inbox`);
  //     },
  //     onCancel: () => { Swal.close(); },
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //     customClass: {
  //       confirmButton: 'custom-swal-confirm',
  //       cancelButton: 'custom-swal-cancel',
  //       closeButtonText: 'custom-swal-close',
  //     },
  //   });
  // } 

const handleShare = (row) => {
  CustomSwal({
    title: "Share Job", 
    html: `
  <div style="text-align:left;">
    <p style="margin-bottom:12px;">
      Do you want to share "<b>${row.jobs_role?.ROLE_NAME}</b>" job with selected clinician?
    </p>

    <label style="display:block; margin-bottom:6px; font-weight:600; font-size:14px;">
      Set Pay Rate
    </label>

    <div style="display:flex; align-items:center; border:1px solid #d9d9d9; border-radius:6px; padding:0 10px;">
      <span style="font-weight:600; margin-right:10px;">$</span>
     <input 
        type="number"
        id="payRate"
        min="0"
        step="0.01"
        placeholder="Enter amount"
        style="border:none; outline:none; width:100%; padding:10px 0;"
        oninput="
          if (this.value.includes('-')) this.value = this.value.replace('-', '');
          const parts = this.value.split('.');
          if (parts[1]?.length > 2) {
            this.value = parts[0] + '.' + parts[1].slice(0,2);
          }
        "
        onwheel="this.blur()"
      />
    </div>
  </div>
`,
    focusConfirm: false,
    preConfirm: () => {
      const payRate = document.getElementById("payRate").value;

      if (!payRate) {
        Swal.showValidationMessage("Please enter a pay rate");
        return false;
      }

      return payRate; // cleaner
    },
    onConfirm: async (payRate) => {
      try {
        await sendOfferToClinician(row?.ID, clinician, payRate);
        toast.success("Offer sent to clinician successfully");
        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: "Offer sent to clinician successfully",
        // });
        navigate(`/facility/clinicians`);
      } catch (error) {
          toast.error(error.response?.data?.message || "Failed to send offer to clinician");
        // Swal.fire({
        //   icon: "error",
        //   title: "Error",
        //   text: error.response?.data?.message || "Failed to send offer to clinician",
        // });
      }
    },
    onCancel: () => {
      Swal.close();
    },
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  });
};

  const requestHireCol = useMemo(() => {
    const baseColumns = [
      {
        name: 'Job Title',
        valuesName: "ROLE_NAME",
        selector: row => row.jobs_role?.ROLE_NAME,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Job Type',
        valuesName: "JOB_TYPE",
        selector: row => row.JOB_TYPE,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Specialty Name',
        valuesName: "SPECIALTY_NAME",
        selector: row => row?.specialty?.SPECIALTY_NAME,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Job Status',
        valuesName: "JOB_STATUS",
        selector: row => row.JOB_STATUS,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Service Date',
        valuesName: "SERVICE_DATE",
        selector: row => row.SERVICE_DATE?new Date(row.SERVICE_DATE).toDateString(): null,
        reorder: true,
      },
      {
        name: 'Posted Date',
        valuesName: "CREATED_DATE",
        selector: row => row.CREATED_DATE,
        sortable: true,
        reorder: true,
      },
      {
        name: 'Applicants',
        selector: row => row?.cliniciansCount || 0,
        reorder: true,
      },
    ];

    if (isFullAccess) {
      baseColumns.push({
        name: 'Actions',
        button: true,
        cell: row => (
          <div style={{ paddingLeft: "15px" }}>
            {routeto === "messages" ? (
              <Tooltip title="Share">
                <IconButton size="small" onClick={() => handleShare(row)}>
                  <ShareIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <>
                <Tooltip title="Edit Job">
                  <IconButton size="small" onClick={() => handleEditJob(row)}>
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="View Job">
                  <IconButton size="small" onClick={() => handleViewJob(row)}>
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </div>
        ),
        reorder: true,
        center: true,
      });
    }

    return baseColumns;
  }, [isFullAccess, routeto]);
  const [tableColumns, setTableColumns] = useState(requestHireCol);

  const selfHireCol = useMemo(() => {
    const baseColumns = [
      {
        name: 'Job Title',
        valuesName: "ROLE_NAME",
        selector: row => row.jobs_role?.ROLE_NAME,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Job Type',
        valuesName: "JOB_TYPE",
        selector: row => row.JOB_TYPE,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Specialty Name',
        valuesName: "SPECIALTY_NAME",
        selector: row => row?.specialty?.SPECIALTY_NAME,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Job Status',
        valuesName: "JOB_STATUS",
        selector: row => row.JOB_STATUS,
        reorder: true,
        sortable: true,
      },
      {
        name: 'Service Date',
        valuesName: "SERVICE_DATE",
        selector: row => row.SERVICE_DATE?new Date(row.SERVICE_DATE).toDateString(): null,
        reorder: true,
      },
      {
        name: 'Posted Date',
        valuesName: "CREATED_DATE",
        selector: row => row.CREATED_DATE,
        sortable: true,
        reorder: true,
      },
      {
        name: 'Applicants',
        selector: row => row?.cliniciansCount || 0,
        reorder: true,
      },
    ];

    if (isFullAccess) {
      baseColumns.push({
        name: 'Actions',
        button: true,
        cell: row => (
          <div style={{ paddingLeft: "15px" }}>
            {routeto === "messages" ? (
              <Tooltip title="Share">
                <IconButton size="small" onClick={() => handleShare(row)}>
                  <ShareIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <>
                <Tooltip title="Edit Job">
                  <IconButton size="small" onClick={() => handleEditJob(row)}>
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="View Job">
                  <IconButton size="small" onClick={() => handleViewJob(row)}>
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </div>
        ),
        reorder: true,
        center: true,
      });
    }

    return baseColumns;
  }, [isFullAccess, routeto]);

  let TabList = [
    { title: "Self Hire", url: "/job/fetchJob", body: { HIRING_TYPE: "Self Hire" }, column: selfHireCol, customUi: false, element: <></> },
    { title: "Requested Hire", url: "/job/fetchJob", body: { HIRING_TYPE: "Request Hire" }, columns: requestHireCol, customUi: false }

  ]

  let addButton = isFullAccess ? <><Grid item>
    <Button variant="contained" onClick={() => {
      dispatch(emptyJob())
      dispatch(update({ MODE: "Add", HIRING_TYPE: "Request Hire", INITIALSTEP: 0 }))
      navigate("/facility/jobs/postJob?type=RequestHiring")
    }} sx={{ background: 'linear-gradient(to right,#4eb3e8,#6ebe44)', }}>Request Hire</Button>

  </Grid>
    <Grid item pl={2}>
      <Button variant="contained" onClick={() => {
        dispatch(emptyJob())
        dispatch(customStep(2))
        dispatch(update({ MODE: "Add", HIRING_TYPE: "Self Hire", INITIALSTEP: 2 }))
        navigate("/facility/jobs/postJob?type=SelfHiring")
      }} sx={{ background: 'linear-gradient(to right,#4eb3e8,#6ebe44)', }}>Self Hire</Button>

    </Grid>
  </> : null;



  return (
    <Grid container>
      {controlBy === "admin" &&

        <Box
          //  position="fixed"
          top={80}
          left={0}
          // px={3}
          display="flex"
          alignItems="center"
          sx={{ cursor: "pointer", marginTop: 4 }}
          onClick={() => navigate(-1)}>
          <ArrowBackIcon fontSize='small' />
          <Typography >Back</Typography>
        </Box >
      }
      <Grid item lg={12} mb={2} mt={2}
        className="facility-table-wrapper">
        <CustomTable
          tabs={TabList}
          column={tableColumns}
          event={(e) => {
            setEvent(e);
            console.log("Selected Tab:", e.activeTab?.title);
            console.log("Selected Tab Data:", e?.query?.data);
            // here you get the selected tab
          }}
          url={"/job/fetchJob"} customButton={addButton} headline={"Jobs"} payload={{ routeto }} />
      </Grid>

    </Grid>

  )
}

export default memo(Jobs);
